(function certificateRRHHDetailControllerDefinition() {
    'use strict';

    angular.module('CertificateRRHH')
        .controller('CertificateRRHHDetailController', [
            '$filter', '$state', '$scope', '$stateParams', '$window', '$translate', 'alerts', 'errorsExtend', 'processService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q',
            function certificateRRHHDetailController($filter, $state, $scope, $stateParams, $window, $translate, alerts, errors, processService, fileWorkflowService, auth, configViewService, $q) {

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.loadCertificate = function () {
                    return processService.getById($stateParams.id).then(function (result) {
                        $scope.certificate = result;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                }

                $scope.loadConfigView = function () {
                    return configViewService.getById('CPPCertificateRRHH').then(function (result) {
                        $scope.configView = result;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                }

                $scope.loadFile = function (fileId) {
                    return fileWorkflowService.getById(fileId)
                }

                $scope.loadActions = function (processType, process) {
                    var result = $filter('filter')(processType.groupStates, function (item) {
                        return item.ids.indexOf(process.stateId) > -1;
                    }, true);

                    if (result.length > 0) {
                        $scope.actions = {
                            delete: result[0].delete,
                            edit: result[0].edit,
                            editName: result[0].editName,
                            retry: result[0].retry,
                            functions: result[0].actions
                        };

                        if ($scope.actions.functions) {
                            var filterExpirationDate = $filter('filter')($scope.certificate.metadataValues, { systemName: '_wfFechaVencimientoCert' }, true);
                            if (filterExpirationDate.length === 0 || isNaN(Date.parse(filterExpirationDate[0].value))) {
                                delete $scope.actions.functions['requestRenovation'];
                                return;
                            }

                            var expirationDate = new Date(filterExpirationDate[0].value);
                            var today = (new Date()).getTime();

                            var renovationPeriodTo = expirationDate.getTime();
                            var renovationPeriodFrom = expirationDate.setDate(expirationDate.getDate() - 30);
                            
                            for (var key in result[0].actions) {
                                if (key === 'requestRenovation' && (today <= renovationPeriodFrom || today >= renovationPeriodTo)) {
                                    delete result[0].actions['requestRenovation'];
                                }
                            }
                        }
                    }
                };

                $scope.retry = function () {
                    return processService.execute($stateParams.id).then(function (result) {
                        errors.showSuccess('ProcessRetryingSuccess');
                        $scope.load();
                    }, function (error) {
                        errors.showError(error);
                        $scope.load();
                    });
                };

                $scope.delete = function () {
                    return $translate(['Warning', 'DeleteCertificateConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DeleteCertificateConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (result) {
                                processService.delete($stateParams.id).then(function () {
                                    $scope.cancel();
                                }, function (error) {
                                    errors.showError(error);
                                });;
                            }
                        });
                    });
                };

                $scope.edit = function (key) {
                    if (key === 'requestRenovation') {
                        return $translate(['Warning', 'RequestRenovationConfirmation', 'Yes', 'No']).then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.RequestRenovationConfirmation, translated.Yes, translated.No).then(function getOk(result) {
                                if (result) {
                                    var preexistente = $filter('filter')($scope.certificate.metadataValues, { systemName: '_eExiste' }, true);

                                    if (preexistente.length > 0) {
                                        preexistente[0].value = true;
                                    }

                                    return processService.checkout($scope.certificate.id).then(function () {
                                        return processService.modifyAndSend($scope.certificate).then(function () {
                                            $state.go('certificate-rrhh-find');
                                        }, function (error) {
                                            errors.showError(error);
                                        });
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }
                            });
                        });
                    } else {
                        // revocar certificado
                        $state.go('certificate-rrhh-edit', { id: $scope.certificate.id });
                    }
                };

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.history = function (proc) {
                    $state.go('process-history', { id: proc.id });
                };

                $scope.load = function () {
                    $scope.actions = {
                        delete: false,
                        retry: false,
                        edit: false,
                        editName: 'Edit'
                    };

                    $scope.userId = auth.getUserId();
                    $scope.continuePermission = auth.isInRole('CERTIFICATE CONTINUE');
                    $scope.processHistoryPermission = auth.isInRole('CERTIFICATE READ');

                    var metadatas = [];

                    $q.all([$scope.loadCertificate(), $scope.loadConfigView()]).then(function () {
                        var result = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.certificate.certificateTypeId }, true);
                        if (result.length == 0) {
                            $scope.certificate.metadataValues = metadatas;
                            return;
                        }

                        result[0].metadatas.forEach(function (certificateMetadata) {
                            if (certificateMetadata.detailCriteria) {
                                var metadataFound = $filter('filter')($scope.certificate.metadataValues, { systemName: certificateMetadata.systemName }, true);
                                var value = null;
                                var desc = null;

                                if (metadataFound.length > 0) {
                                    value = metadataFound[0].value;
                                    desc = metadataFound[0].description;
                                }

                                metadatas.push({
                                    metadataId: certificateMetadata.metadataId,
                                    type: certificateMetadata.metadataType != null ? certificateMetadata.metadataType.toLowerCase() : undefined,
                                    name: certificateMetadata.detailCriteria.name,
                                    isVisible: certificateMetadata.systemName != '_eExiste' && certificateMetadata.systemName != '_eRevocado',
                                    maskOptions: certificateMetadata.maskOptions,
                                    systemName: certificateMetadata.systemName,
                                    order: certificateMetadata.detailCriteria.order,
                                    value: value,
                                    description: desc,
                                    mask: certificateMetadata.detailCriteria.mask
                                });
                            }
                        });

                        metadatas.sort(function (a, b) {
                            return a.order - b.order;
                        });

                        $scope.certificate.metadataValues = metadatas;

                        $scope.loadActions(result[0], $scope.certificate);
                    });
                };

                $scope.load();
            }
        ]);
})();
